import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'react-bootstrap';
import PropdocsModal from '../modal/PropdocsModal';
import SubmitButton from '../submit-button';
import styles from './DeleteItemModal.module.scss';

interface DeleteItemModalProps {
  show: boolean;
  setShow: (show: boolean) => void;
  itemContent: string;
  onConfirm: () => Promise<void>;
  isDeleting: boolean;
}

export const DeleteItemModal: React.FC<DeleteItemModalProps> = ({
  show,
  setShow,
  itemContent,
  onConfirm,
  isDeleting,
}) => {
  const handleConfirm = async () => {
    await onConfirm();
    setShow(false);
  };

  return (
    <PropdocsModal
      size="sm"
      show={show}
      setShow={() => setShow(false)}
      title={<FormattedMessage id="checklist.item.delete-title" defaultMessage="Delete Item" />}
    >
      <>
        <div className={styles.modalBody}>
          <p>
            <FormattedMessage id="checklist.item.delete-confirm" defaultMessage="Are you sure you want to delete this checklist item?" />
          </p>
          <p>
            <strong>{itemContent}</strong>
          </p>
          <p className={styles.warningText}>
            <FormattedMessage id="checklist.item.delete-warning" defaultMessage="This action cannot be undone." />
          </p>
        </div>

        <div className={styles.modalActions}>
          <Button variant="link" onClick={() => setShow(false)} disabled={isDeleting}>
            <FormattedMessage id="cta.cancel" defaultMessage="Cancel" />
          </Button>
          <SubmitButton
            label={<FormattedMessage id="cta.delete" defaultMessage="Delete" />}
            disabled={isDeleting}
            isSubmitting={isDeleting}
            onClick={handleConfirm}
            variant="danger"
          />
        </div>
      </>
    </PropdocsModal>
  );
};

export default DeleteItemModal;
